import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-top: 10px;
`

export const ActionButton = styled.button`
  background: none;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  cursor: pointer;
`
export const ChargeSelect = styled.select`
  background: none;
  border: 1px solid ${(props) => (props.value === 0 ? '#C28220' : '#2F9D6C')};
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 10px;
`
